function Test6 (props) {
  return <div>?</div>
}

export default Test6;